import React from 'react';
import { PurchaseOrderWizard } from './PurchaseOrderWizard';
import { PurchaseOrderProps } from '@/components/campaign/types/purchaseOrderV2';

export const PurchaseOrderDialog: React.FC<PurchaseOrderProps & { onBackToPaymentPlan?: () => void }> = (props) => {
  return <PurchaseOrderWizard {...props} />;
};